import { normalizeState } from "./commercial.mjs";
import { initialState } from "./repository.mjs";

export function connectClients(clients, user, saved) {
  const previous = saved?.clients || [];
  const mapped = clients.map(client => {
    const existing = previous.find(row => row.establishment_id === client._id || row.id === client._id);
    const contacts = (client.contacts || []).map((contact, index) => ({
      ...contact, id: contact._id || `${client._id}-contact-${index}`,
      name: [contact.firstname, contact.lastname].filter(Boolean).join(" "),
      firstName: contact.firstname || "", lastName: contact.lastname || "",
      role: contact.profession || "", phone: contact.mobile || contact.phone || "",
      email: contact.email || "", active: contact.active !== false, primary: index === 0,
    }));
    if (!contacts.length && (client.contactFirstname || client.contactLastname || client.contactPhone || client.contactEMail)) contacts.push({id:`${client._id}-contact`,name:[client.contactFirstname,client.contactLastname].filter(Boolean).join(" "),phone:client.contactPhone || "",email:client.contactEMail || "",active:true,primary:true});
    const hasPld = client.pld != null && String(client.pld).trim() !== "";
    return {
      ...existing, apiClient: true, id: client._id, establishment_id: client._id, client_id: client._id,
      name: client.companyName || "Entreprise sans nom", siret: client.siret || "",
      address: client.address || "", postalCode: client.postCode || "", city: client.town || "",
      phone: client.contactPhone || "", email: client.contactEMail || "",
      kind: hasPld ? "client" : "prospect", status: existing?.status || (hasPld ? "CLIENT ACTIF" : "PROSPECT"),
      agency: user.agency, ownerId: user.id, owner: user.name,
      contacts: existing?.contacts?.length ? existing.contacts : contacts,
    };
  });
  // Preserve locally imported prospects; never load the prototype's demo database.
  const imported = previous.filter(row => !row.apiClient && !mapped.some(client => client.id === row.id));
  return normalizeState({ ...(saved || initialState([])), clients: [...mapped, ...imported] });
}
